// const API_BASE_URL = process.env.REACT_APP_API_URL;
const API_BASE_URL = process.env.REACT_APP_API_URL || window.APP_CONFIG.REACT_APP_API_URL

const POST_API_PATH = {
    POST_URL_SMSCODE: `${API_BASE_URL}/SMS/getSMScode`,
    POST_URL_SEND_SMSCODE: `${API_BASE_URL}/SMS/verifySMScode`,

    POST_URL_DELIVER_ORDERS: `${API_BASE_URL}/order/deliverOrders`,
    POST_URL_CREATE_ORDER: `${API_BASE_URL}/order/createNewOrder`,
    POST_URL_UPDATE_ORDER: `${API_BASE_URL}/order/updateOrder`,
    POST_URL_DELETE_ORDER: `${API_BASE_URL}/order/deleteOrder`,
    POST_URL_UPLOAD_ORDER_IMAGE: `${API_BASE_URL}/order/uploadOrderImage`,
    POST_URL_UPDATE_ORDER_DELIVER: `${API_BASE_URL}/order/specifyDeliver`,

    POST_URL_UPDATE_ORDER_RULE: `${API_BASE_URL}/orderRule/updateOrderRule`,

    POST_URL_CREATE_DELIVER: `${API_BASE_URL}/employees/createDeliver`,
    POST_URL_UPDATE_DELIVER: `${API_BASE_URL}/employees/updateDeliver`,
    POST_URL_DELETE_DELIVER: `${API_BASE_URL}/employees/deleteDeliver`,
    POST_URL_RESET_PASSWORD: `${API_BASE_URL}/employees/resetPassword`,

    POST_URL_ENSUREEXISTS_DELIVER_RECORD: `${API_BASE_URL}/deliveryRecord/ensureExists`,
    POST_URL_UPDATE_DELIVERY_RECORD: `${API_BASE_URL}/deliveryRecord/updateDeliveryRecord`,
    POST_URL_DELETE_DELIVERY_RECORD: `${API_BASE_URL}/deliveryRecord/deleteDeliveryRecord`,

    POST_URL_CREATE_ADDRESS_OPTION: `${API_BASE_URL}/addressOptions/createAddressOption`,
    POST_URL_UPDATE_ADDRESS_OPTION: `${API_BASE_URL}/addressOptions/updateAddressOption`,
    POST_URL_DELETE_ADDRESS_OPTION: `${API_BASE_URL}/addressOptions/deleteAddressOption`,

    POST_URL_CREATE_DELIVER_ORDER: `${API_BASE_URL}/deliverOrders/createDeliverOrders`,
    POST_URL_UPDATE_DELIVER_ORDER: `${API_BASE_URL}/deliverOrders/updateDeliverOrders`,
    POST_URL_RETURN_DELIVER_ORDER: `${API_BASE_URL}/deliverOrders/returnDeliverOrders`,
    POST_URL_COMPLETE_DELIVERY: `${API_BASE_URL}/deliverOrders/complete`,

    POST_URL_OPR_OPTIMIZEROUTR: `${API_BASE_URL}/OPR/optimizeRoute`,

    // truckLoanApplication
    POST_URL_CREATE_TRUCK_LOAN_APPLICATION: `${API_BASE_URL}/truckLoanApplication`,
    POST_URL_APPROVE_TRUCK_LOAN_APPLICATION: `${API_BASE_URL}/truckLoanApplication/approve`,
    POST_URL_REJECT_TRUCK_LOAN_APPLICATION: `${API_BASE_URL}/truckLoanApplication/reject`,
    POST_URL_RETURN_TRUCK_LOAN_APPLICATION: `${API_BASE_URL}/truckLoanApplication/return`,
    POST_URL_APPROVE_RETURN_TRUCK_LOAN_APPLICATION: `${API_BASE_URL}/truckLoanApplication/approveReturn`,
    POST_URL_CANCEL_TRUCK_LOAN_APPLICATION: `${API_BASE_URL}/truckLoanApplication/cancel`,
    POST_URL_APPROVE_CANCEL_REQUEST: `${API_BASE_URL}/truckLoanApplication/approveCancelRequest`,

    // notification
    POST_URL_NOTIFICATION_READ: `${API_BASE_URL}/notification/read`,
    POST_URL_NOTIFICATION_MARK_READ: `${API_BASE_URL}/notification/markRead`,
    POST_URL_NOTIFICATION_READ_ALL: `${API_BASE_URL}/notification/read-all`,


}
export { POST_API_PATH }